import React, { useState, useEffect, useRef, useCallback } from 'react';
import { connect } from "react-redux";
import { Popup } from 'devextreme-react';
import { Button } from 'devextreme-react/button';
import { LoadPanel } from 'devextreme-react/load-panel';
import { TabPanel, Item as TabItem } from 'devextreme-react/tab-panel';
import FormField from '../../../../../../dynamicFormBuilder/FormField';
import { IDLookupLayout, IDCarrierLookupLayout, IDEquipmentLookupLayout, IDDriverLookupLayout, IDWarehouseLookupLayout } from '../../../../../../common/lookups/Layouts/IdLayouts';
import { IMLocationLookupLayout } from '../../../../../../common/lookups/Layouts/ImLayouts';
import { createStore } from 'devextreme-aspnet-data-nojquery';
import DataSource from "devextreme/data/data_source";
import axios from 'axios';
import notify from 'devextreme/ui/notify';
import { alert } from 'devextreme/ui/dialog';
import { ERROR_SEVERITY, formatErrorList } from '../../../../../../common/apiErrors';
import { CONCURRENCY_HANDLED, getApiErrorMessage } from '../../../../../../common/concurrency';

const PrimaryLayout = [
    {
        groupId: 1,
        label: "Transportation",
        fields: [
            {
                name: "TRANSPORTATIONMODE",
                tableName: "WMTRANSACTIONHEADER",
                label: "Transportation Mode",
                type: "select",
                options: [""],
                required: false,
                visible: true,
                searchEnabled: false,
                isLabelChanged: false,
            },
            {
                name: "R_AGENT",
                tableName: "WMTRANSACTIONHEADER",
                label: "Agent",
                type: "lookup",
                layout: IDLookupLayout,
                required: false,
                visible: true,
                isLabelChanged: false,
            },
            {
                name: "R_CARRIER",
                tableName: "WMTRANSACTIONHEADER",
                label: "Carrier",
                type: "lookup",
                layout: IDCarrierLookupLayout,
                required: false,
                visible: true,
                isLabelChanged: false,
            },
            {
                name: "R_TRANSPORTCARRIER",
                tableName: "WMTRANSACTIONHEADER",
                label: "Trans Carrier",
                type: "lookup",
                layout: IDCarrierLookupLayout,
                required: false,
                visible: true,
                isLabelChanged: false,
            },
            {
                name: "EQUIPMENTTYPE",
                tableName: "WMTRANSACTIONHEADER",
                label: "Equipment",
                type: "lookup",
                "layout": IDEquipmentLookupLayout({ equipmenttype: 'P' }),
                required: false,
                visible: true,
                isLabelChanged: false,
            },
            {
                name: "R_EQUIPMENT",
                tableName: "WMTRANSACTIONHEADER",
                label: "Truck",
                type: "lookup",
                "layout": IDEquipmentLookupLayout({ equipmenttype: 'P' }),
                required: false,
                visible: true,
                isLabelChanged: false,
            },
            {
                name: "R_DRIVER",
                tableName: "WMTRANSACTIONHEADER",
                label: "Driver",
                type: "lookup",
                layout: IDDriverLookupLayout,
                required: false,
                visible: true,
                isLabelChanged: false,
            },
            {
                name: "TRUCKREFERENCE",
                tableName: "WMTRANSACTIONHEADER",
                label: "Reference #",
                type: "text",
                required: false,
                visible: true,
                isLabelChanged: false,
            },
            {
                name: "CONTAINER",
                tableName: "WMTRANSACTIONHEADER",
                label: "Container #",
                type: "text",
                required: false,
                visible: true,
                isLabelChanged: false,
            },
            {
                name: "EQUIPMENTINTERCHANGEREPORT",
                tableName: "WMTRANSACTIONHEADER",
                label: "Trailer #/EIR",
                type: "text",
                required: false,
                visible: true,
                isLabelChanged: false,
            },
           

        ]
    },
    {
        groupId: 1,
        label: "Dock/Yard Information",
        fields: [
            {
                name: "DELIVERYPICKUPDEPARTDATETIME",
                tableName: "WMTRANSACTIONHEADER",
                label: "Yard Arrive",
                type: "datetime",
                required: false,
                visible: true,
                isLabelChanged: false,
            },
            {
                name: "TRUCKARRIVALDATETIME",
                tableName: "WMTRANSACTIONHEADER",
                label: "Dock Start",
                type: "datetime",
                required: false,
                visible: true,
                isLabelChanged: false,
            },
            {
                name: "TRUCKDEPARTDATETIME",
                tableName: "WMTRANSACTIONHEADER",
                label: "Dock End",
                type: "datetime",
                required: false,
                visible: true,
                isLabelChanged: false,
            },
            {
                name: "TRANSPORTATIONYARDLEAVEDATE",
                tableName: "WMTRANSACTIONHEADER",
                label: "Yard Leave",
                type: "datetime",
                required: false,
                visible: true,
                isLabelChanged: false,
            }, {
                name: "R_TRANSPORTATIONWAREHOUSE",
                tableName: "WMTRANSACTIONHEADER",
                label: "Warehouse",
                type: "lookup",
                layout: IDWarehouseLookupLayout,
                required: false,
                visible: true,
                isLabelChanged: false,
            },
            {
                name: "R_TRANSPORTATIONLOCATION",
                tableName: "WMTRANSACTIONHEADER",
                label: "Location",
                type: "lookup",
                layout: IMLocationLookupLayout({ moduleType: "IM", runtimeParameter: JSON.stringify([{ R_TRANSPORTATIONWAREHOUSE: 'RWarehouse' }]) }),
                required: false,
                visible: true,
                isLabelChanged: false,
            },
            {
                name: "COMMENT",
                tableName: "WMTRANSACTIONHEADER",
                label: "Comment",
                type: "text",
                required: false,
                visible: true,
                isLabelChanged: false,
            },
        ]
    }
];

const AdditionalLayout = [
    {
        groupId: 1,
        label: "",
        fields: [
            {
                name: "USERDEFINEDDATE_1",
                tableName: "WMTRANSACTIONHEADER",
                label: "Date1",
                type: "datetime",
                required: false,
                visible: true,
                isLabelChanged: false,
            },
            {
                name: "USERDEFINEDDATE_2",
                tableName: "WMTRANSACTIONHEADER",
                label: "Date2",
                type: "datetime",
                required: false,
                visible: true,
                isLabelChanged: false,
            },
            {
                name: "USERDEFINEDDATE_3",
                tableName: "WMTRANSACTIONHEADER",
                label: "Date3",
                type: "datetime",
                required: false,
                visible: true,
                isLabelChanged: false,
            },
            {
                name: "USERDEFINEDDATE_4",
                tableName: "WMTRANSACTIONHEADER",
                label: "Date4",
                type: "datetime",
                required: false,
                visible: true,
                isLabelChanged: false,
            },
            {
                name: "USERDEFINEDDATE_5",
                tableName: "WMTRANSACTIONHEADER",
                label: "Date5",
                type: "datetime",
                required: false,
                visible: true,
                isLabelChanged: false,
            },
            {
                name: "USERDEFINEDREFERENCE_1",
                tableName: "WMTRANSACTIONHEADER",
                label: "Reference1",
                type: "text",
                required: false,
                visible: true,
                isLabelChanged: false,
            },
            {
                name: "USERDEFINEDREFERENCE_2",
                tableName: "WMTRANSACTIONHEADER",
                label: "Reference2",
                type: "text",
                required: false,
                visible: true,
                isLabelChanged: false,
            },
            {
                name: "USERDEFINEDREFERENCE_3",
                tableName: "WMTRANSACTIONHEADER",
                label: "Reference3",
                type: "text",
                required: false,
                visible: true,
                isLabelChanged: false,
            },
            {
                name: "USERDEFINEDREFERENCE_4",
                tableName: "WMTRANSACTIONHEADER",
                label: "Reference4",
                type: "text",
                required: false,
                visible: true,
                isLabelChanged: false,
            },
            {
                name: "USERDEFINEDREFERENCE_5",
                tableName: "WMTRANSACTIONHEADER",
                label: "Reference5",
                type: "text",
                required: false,
                visible: true,
                isLabelChanged: false,
            },
        ]
    },
    {
        groupId: 2,
        label: "",
        fields: [
            {
                name: "CODCOLLECTIONDATETIME",
                tableName: "WMTRANSACTIONHEADER",
                label: "Date",
                type: "datetime",
                required: false,
                visible: true,
                isLabelChanged: false,
            }
        ]
    }
];

const transportationModeOptions = [
    { Rowid: "T", Code: "Company Truck" },
    { Rowid: "S", Code: "Outside Truck" },
    { Rowid: "A", Code: "Air" },
    { Rowid: "R", Code: "Rail" },
    { Rowid: "O", Code: "Ocean" },
    { Rowid: "B", Code: "Barge" },
    { Rowid: "L", Code: "LTL (Less Than Truck Load)" },
    { Rowid: "P", Code: "Customer Pickup" },
    { Rowid: "C", Code: "Container" }
];

const loadPanelPosition = { of: window };

const Transportation = ({ visible, onClose, transactionRowId, accessToken, oidc }) => {
    const [loading, setLoading] = useState(false);
    const [formFields, setFormFields] = useState({});
    const [transactionData, setTransactionData] = useState(null);
    const formRefs = useRef({});
    const currentUser = oidc?.user;
    const DYNAMICFORMSETTING = oidc?.user?.profile?.DYNAMICFORMSETTING;

    useEffect(() => {
        if (visible && transactionRowId) {
            loadTransaction();
        }
        if (!visible) {
            setFormFields({});
            setTransactionData(null);
        }
    }, [visible, transactionRowId]);

    const loadTransaction = async () => {
        setLoading(true);
        try {
            const response = await axios.get(
                `${window._env_.REACT_APP_APIS}/wm/Transaction/GetTransactionByRowId?rowid=${transactionRowId}`,
                {
                    headers: {
                        access_token: accessToken,
                        Authorization: `Bearer ${accessToken}`
                    }
                }
            );
            const data = response.data;
            setTransactionData(data);
            setFormFields({
                TRANSPORTATIONMODE: data?.TRANSPORTATIONMODE || null,
                USERDEFINEDDATE_1: data?.USERDEFINEDDATE_1 || null,
                R_AGENT: data?.R_AGENT || null,
                R_CARRIER: data?.R_CARRIER || null,
                R_TRANSPORTCARRIER: data?.R_TRANSPORTCARRIER || null,
                EQUIPMENTTYPE: data?.EQUIPMENTTYPE || null,
                R_EQUIPMENT: data?.R_EQUIPMENT || null,
                R_DRIVER: data?.R_DRIVER || null,
                TRUCKREFERENCE: data?.TRUCKREFERENCE || null,
                CONTAINER: data?.CONTAINER || null,
                EQUIPMENTINTERCHANGEREPORT: data?.EQUIPMENTINTERCHANGEREPORT || null,
                DELIVERYPICKUPDEPARTDATETIME: data?.DELIVERYPICKUPDEPARTDATETIME || null,
                TRUCKARRIVALDATETIME: data?.TRUCKARRIVALDATETIME || null,
                TRUCKDEPARTDATETIME: data?.TRUCKDEPARTDATETIME || null,
                TRANSPORTATIONYARDLEAVEDATE: data?.TRANSPORTATIONYARDLEAVEDATE || null,
                R_TRANSPORTATIONWAREHOUSE: data?.R_TRANSPORTATIONWAREHOUSE || null,
                R_TRANSPORTATIONLOCATION: data?.R_TRANSPORTATIONLOCATION || null,
                COMMENT: data?.COMMENT || null,
                USERDEFINEDDATE_2: data?.USERDEFINEDDATE_2 || null,
                USERDEFINEDDATE_3: data?.USERDEFINEDDATE_3 || null,
                USERDEFINEDDATE_4: data?.USERDEFINEDDATE_4 || null,
                USERDEFINEDDATE_5: data?.USERDEFINEDDATE_5 || null,
                USERDEFINEDREFERENCE_1: data?.USERDEFINEDREFERENCE_1 || null,
                USERDEFINEDREFERENCE_2: data?.USERDEFINEDREFERENCE_2 || null,
                USERDEFINEDREFERENCE_3: data?.USERDEFINEDREFERENCE_3 || null,
                USERDEFINEDREFERENCE_4: data?.USERDEFINEDREFERENCE_4 || null,
                USERDEFINEDREFERENCE_5: data?.USERDEFINEDREFERENCE_5 || null,
                CODCOLLECTIONDATETIME: data?.CODCOLLECTIONDATETIME || null
            });
        } catch (error) {
            console.error('Error loading transaction:', error);
            alert("Error loading transaction.", "Error");
        } finally {
            setLoading(false);
        }
    };

    const handleFieldChange = useCallback((name, value) => {
        if (name === 'R_TRANSPORTATIONWAREHOUSE') {
            if (formRefs.current['R_TRANSPORTATIONLOCATION']) {
                formRefs.current['R_TRANSPORTATIONLOCATION'].instance().option('value', null);
            }
            if (value) {
                var locationDataSource = new DataSource({
                    store: new createStore({
                        key: 'id',
                        loadUrl: `${window._env_.REACT_APP_APIS}/im/Lookup/GetLocations`,
                        loadParams: {
                            locationTypes: 'L',
                            warehouseRowId: value
                        },
                        onBeforeSend: function (method, ajaxOptions) {
                            ajaxOptions.headers = {
                                Authorization: `Bearer ${accessToken}`
                            };
                        }
                    }),
                    paginate: true,
                    pageSize: 100
                });
                if (formRefs.current['R_TRANSPORTATIONLOCATION']) {
                    formRefs.current['R_TRANSPORTATIONLOCATION'].instance().option('dataSource', locationDataSource);
                }
            }
        }
    }, [accessToken]);

    const handlePrimaryFormLoad = useCallback(() => {
        if (formRefs.current['TRANSPORTATIONMODE']) {
            const newOptions = transportationModeOptions.map(item => ({
                id: item.Rowid,
                name: item.Code
            }));
            formRefs.current['TRANSPORTATIONMODE'].instance().option('dataSource', newOptions);
            formRefs.current['TRANSPORTATIONMODE'].instance().option('valueExpr', 'id');
            formRefs.current['TRANSPORTATIONMODE'].instance().option('displayExpr', 'name');
        }
    }, []);

    const handleAdditionalFormLoad = useCallback(() => {
    }, []);

    const handleSave = async () => {
        if (!transactionData) return;
        setLoading(true);
        try {
            const { Profile, Carrier, isLineItemExist, UserValidationMessage, ItemTotalQuanity, ItemTotalChargeAmount, TotalChargesCount, CustomerAddress, CustomerCreditLimit, CustomerCreditBalance, CustomerCreditRemaning, ...cleanData } = transactionData;
            const updatedData = { ...cleanData, TRANSPORTATIONMODE: formFields.TRANSPORTATIONMODE, USERDEFINEDDATE_1: formFields.USERDEFINEDDATE_1, R_AGENT: formFields.R_AGENT, R_CARRIER: formFields.R_CARRIER, R_TRANSPORTCARRIER: formFields.R_TRANSPORTCARRIER, EQUIPMENTTYPE: formFields.EQUIPMENTTYPE, R_EQUIPMENT: formFields.R_EQUIPMENT, R_DRIVER: formFields.R_DRIVER, TRUCKREFERENCE: formFields.TRUCKREFERENCE, CONTAINER: formFields.CONTAINER, EQUIPMENTINTERCHANGEREPORT: formFields.EQUIPMENTINTERCHANGEREPORT, DELIVERYPICKUPDEPARTDATETIME: formFields.DELIVERYPICKUPDEPARTDATETIME, TRUCKARRIVALDATETIME: formFields.TRUCKARRIVALDATETIME, TRUCKDEPARTDATETIME: formFields.TRUCKDEPARTDATETIME, TRANSPORTATIONYARDLEAVEDATE: formFields.TRANSPORTATIONYARDLEAVEDATE, R_TRANSPORTATIONWAREHOUSE: formFields.R_TRANSPORTATIONWAREHOUSE, R_TRANSPORTATIONLOCATION: formFields.R_TRANSPORTATIONLOCATION, COMMENT: formFields.COMMENT, USERDEFINEDDATE_2: formFields.USERDEFINEDDATE_2, USERDEFINEDDATE_3: formFields.USERDEFINEDDATE_3, USERDEFINEDDATE_4: formFields.USERDEFINEDDATE_4, USERDEFINEDDATE_5: formFields.USERDEFINEDDATE_5, USERDEFINEDREFERENCE_1: formFields.USERDEFINEDREFERENCE_1, USERDEFINEDREFERENCE_2: formFields.USERDEFINEDREFERENCE_2, USERDEFINEDREFERENCE_3: formFields.USERDEFINEDREFERENCE_3, USERDEFINEDREFERENCE_4: formFields.USERDEFINEDREFERENCE_4, USERDEFINEDREFERENCE_5: formFields.USERDEFINEDREFERENCE_5, CODCOLLECTIONDATETIME: formFields.CODCOLLECTIONDATETIME };
            const res = await axios.put(
                `${window._env_.REACT_APP_APIS}/wm/Transaction/PutTransaction`,
                updatedData,
                {
                    headers: {
                        "Content-Type": "application/json",
                        access_token: accessToken,
                        Authorization: `Bearer ${accessToken}`
                    }
                }
            );
            // Reaching here means the save happened: PutTransaction now enforces the transaction-profile
            // rules that used to be checked only by the data-entry form's pre-flight call, and reports a
            // refusal as a real 400 — so a refusal lands in the catch below, not here.
            notify("Transportation saved successfully.", "success", 3000);
            onClose();
        } catch (error) {
            console.error('Error saving:', error);
            // A version conflict is already handled globally by the axios interceptor.
            if (error?.[CONCURRENCY_HANDLED]) {
                return;
            }
            // The 400 body is the full envelope, so prefer its errors[]. The previous
            // `error.response.data` would now alert the literal text "[object Object]".
            alert(formatErrorList(error?.response?.data?.errors, ERROR_SEVERITY.ERROR)
                || getApiErrorMessage(error, "Error saving transportation."), "Error");
        } finally {
            setLoading(false);
        }
    };

    return (
        <React.Fragment>
            <LoadPanel
                shadingColor="rgba(0,0,0,0.4)"
                position={loadPanelPosition}
                visible={loading}
                showIndicator={true}
                shading={true}
                showPane={true}
                hideOnOutsideClick={false}
            />
            <Popup
                visible={visible && !!transactionData}
                onHiding={onClose}
                dragEnabled={true}
                hideOnOutsideClick={false}
                showCloseButton={true}
                showTitle={true}
                title={`WM Transportation Entry (${transactionData?.TRANSACTIONNUMBER || ''})`}
                width={800}
                height={750}
            >
                <style>{`.staging-assignments-form .flex-container { display: block !important; }`}</style>
                <div id="transportationContainer" className="staging-assignments-form" style={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
                    <div style={{ flex: 1, overflow: 'hidden' }}>
                        <TabPanel showNavButtons={true} deferRendering={false}>
                            <TabItem title="Primary">
                                <div style={{ padding: '15px' }}>
                                    <FormField
                                        currrentUser={currentUser}
                                        layoutId='3F5DE8E3-BC98-44E8-959D-95024AA2EA77'
                                        layoutName='TransportationPrimaryForm'
                                        defaultFormSchema={PrimaryLayout}
                                        formFields={formFields}
                                        setformFields={setFormFields}
                                        handleFieldValueChange={handleFieldChange}
                                        DYNAMICFORMSETTING={DYNAMICFORMSETTING}
                                        formRefs={formRefs}
                                        onFormLoad={handlePrimaryFormLoad}
                                    />
                                </div>
                            </TabItem>
                            <TabItem title="Additional">
                                <div style={{ padding: '15px' }}>
                                    <FormField
                                        currrentUser={currentUser}
                                        layoutId='4A5DE8E3-BC98-44E8-959D-95024AA2EA78'
                                        layoutName='TransportationAdditionalForm'
                                        defaultFormSchema={AdditionalLayout}
                                        formFields={formFields}
                                        setformFields={setFormFields}
                                        handleFieldValueChange={handleFieldChange}
                                        DYNAMICFORMSETTING={DYNAMICFORMSETTING}
                                        formRefs={formRefs}
                                        onFormLoad={handleAdditionalFormLoad}
                                    />
                                </div>
                            </TabItem>
                        </TabPanel>
                    </div>
                    <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '10px', padding: '10px', borderTop: '1px solid #eee' }}>
                        <Button text="Save" type="default" icon="save" onClick={handleSave} />
                        <Button text="Cancel" type="normal" icon="close" onClick={onClose} />
                    </div>
                </div>
            </Popup>
        </React.Fragment>
    );
};

function mapStateToProps(state) {
    return {
        oidc: state.oidc,
    };
}

export default connect(mapStateToProps)(Transportation);
